


































































import companyTypes from '@/store/types/company';
import contactTypes from '@/store/types/contact';

// Components
import companyInfo from '@/components/Company/newCompany/companyInfo.vue';
import documents from '@/components/Company/newCompany/documents.vue';
import { TeipNotifications } from '@/util/teipNotifications';
import { AxiosError } from 'axios';
import { Route } from 'vue-router';
import SweetAlert from '@/util/classes/SweetAlert';
import copyObj from '@/util/copyObj';
import { IObjectKeys } from '@/store/interfaces/generic';
import document from '@/store/types/document';
import { navLink } from '@/ts/navegationLinks';
import { ValidationProvider } from 'vee-validate';
import liquidations from '@/store/types/liquidations';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'NewCompany',
  components: {
    companyInfo,
    documents,
  },
  beforeRouteLeave(to: Route, from: Route, next) {
    if (to.name !== 'new-company') {
      this.$store.commit(
        `companyModule/${companyTypes.mutations.SET_CLEAN_DATA}`
      );
    }
    next();
  },
  data: () => ({
    company_saved_id: '',
    isSaveSuccess: false,
    tabIndex: 0,
    model: {},
    loading: true,
    navlink: [
      {
        name: '', // Assigned in created
        active: false,
        to: '/commerce/company',
      },
      {
        name: '', // Assigned in created
        active: true,
      }
    ] as navLink[],
    newCompanyKey: 1,
  }),
  created(): void {
    this.navlink[0].name = this.$t('menu.company.singular.formal').toString();
    this.navlink[1].name = `Nueva ${this.$t(
      'menu.company.singular.informal'
    ).toString()}`;
  },
  async mounted(): Promise<void> {
    this.listDocumentKind();
    this.liquidationKindList();

    if (this.getContactKind.data.length === 0) {
      await this.listContactKind();
    }
    this.loading = false;
  },
  computed: {
    ...mapGetters({
      getContactKind: `contactModule/${contactTypes.getters.GET_CONTACT_KIND}`,
      getNewCompanyParams: `companyModule/${companyTypes.getters.GET_NEW_COMPANY_PARAMS}`,
    }),
  },
  methods: {
    ...mapActions({
      listContactKind: `contactModule/${contactTypes.actions.LIST_CONTACT_KIND}`,
      saveCompany: `companyModule/${companyTypes.actions.SAVE_COMPANY}`,
      listDocumentKind: `documentModule/${document.actions.LIST_DOCUMENT_KIND}`,
      liquidationKindList: `liquidationModule/${liquidations.actions.LIQUIDATION_KIND_LIST}`,
    }),
    cancel(): void {
      const swal = new SweetAlert();
      swal
        .askingSweetAlert({
          title: '¿Estás seguro?',
          text: 'Es posible que los cambios que realizó no se guarden',
          cancelButtonText: 'Salir',
          confirmButtonText: 'Continuar',
          alertType: 'warning',
        })
        .then((res) => {
          if (!res) {
            this.$router.push({
              name: 'company',
            });

            this.$nextTick(() => {
              this.$store.commit(
                `companyModule/${companyTypes.mutations.SET_CLEAN_DATA}`
              );
            });
          }
        });
    },
    firstFormSubmit(): void {
      const companyParams = this.getNewCompanyParams;
      const commission: IObjectKeys = copyObj(companyParams.commission);

      if (companyParams.model.business_turn === '') {
        delete companyParams.model.business_turn;
      }

      const dataForReference = {
        ...companyParams.model,
        contacts: companyParams.contacts,
        address: { ...companyParams.address, },
        commission,
      };

      this.model = dataForReference;
      this.tabIndex = 1;
      window.scrollTo(0, 0);
    },
    saveNewCompany(images: { image: string }[]): void {
      const teipNotification = new TeipNotifications();
      if (Object.keys(this.model).length !== 0) {
        this.saveCompany({
          model: this.model,
          images,
        })
          .then(() => {
            this.isSaveSuccess = true;
            this.newCompanyKey++;
            this.tabIndex = 0;
            teipNotification.success(
              `${this.$t(
                'menu.company.singular.formal'
              )} guardada exitosamente.`
            );
          })
          .catch((error: AxiosError) => {
            if (error.response && error.response?.status === 422) {
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              const errors: Array<any> = Object.entries(
                error.response?.data.error
              );
              const errorsShow: string[] = [];
              errors.map(([key, value]) => {
                if (key.includes('contacts')) {
                  const keys = key.split('.')[1];
                  errorsShow[keys] = value;
                } else {
                  errorsShow[key] = value;
                }
              });
              (
                this.$refs.formValidatorNewCompany as InstanceType<
                  typeof ValidationProvider
                >
              ).setErrors(errorsShow);
            } else {
              teipNotification.warning('Algo salió mal :(');
            }
          })
          .finally(() => {
            this.isSaveSuccess = false;
          });
      } else {
        this.tabIndex = 0;
        teipNotification.warning(
          `¡Información de ${this.$t(
            'menu.company.singular.informal'
          )} requerida!`,
          `Debes completas la información de ${this.$t(
            'menu.company.singular.informal'
          )} para poder guardar contactos`
        );
      }
    },
  },
});

// @Component({
//   name: 'NewCompany',
//   components: {
//     companyInfo,
//     documents,
//   },
//   beforeRouteLeave(to: Route, from: Route, next) {
//     if (to.name !== 'new-company') {
//       this.$store.commit(
//         `companyModule/${companyTypes.mutations.SET_CLEAN_DATA}`
//       );
//     }
//     next();
//   },
// })
// class NewCompany extends Vue {
//   @Ref('formValidatorNewCompany')
//   readonly formValidatorNewCompany!: InstanceType<typeof ValidationProvider>;

//   @Ref('documents') readonly documents!: InstanceType<typeof documents>;

//   company_saved_id = '';
//   isSaveSuccess = false;
//   tabIndex = 0;
//   model = {};
//   loading = true;
//   navlink: navLink[] = [
//     {
//       name: '', // Assigned in created
//       active: false,
//       to: '/commerce/company',
//     },
//     {
//       name: '', // Assigned in created
//       active: true,
//     }
//   ];

//   newCompanyKey = 1;

//   created(): void {
//     this.navlink[0].name = this.$t('menu.company.singular.formal').toString();
//     this.navlink[1].name = `Nueva ${this.$t(
//       'menu.company.singular.informal'
//     ).toString()}`;
//   }

//   async mounted(): Promise<void> {
//     this.listDocumentKind();
//     this.liquidationKindList();

//     if (this.getContactKind.data.length === 0) {
//       await this.listContactKind();
//     }
//     this.loading = false;
//   }

//   cancel(): void {
//     const swal = new SweetAlert();
//     swal
//       .askingSweetAlert({
//         title: '¿Estás seguro?',
//         text: 'Es posible que los cambios que realizó no se guarden',
//         cancelButtonText: 'Salir',
//         confirmButtonText: 'Continuar',
//         alertType: 'warning',
//       })
//       .then((res) => {
//         if (!res) {
//           this.$router.push({
//             name: 'company',
//           });

//           this.$nextTick(() => {
//             this.$store.commit(
//               `companyModule/${companyTypes.mutations.SET_CLEAN_DATA}`
//             );
//           });
//         }
//       });
//   }

//   firstFormSubmit(): void {
//     const companyParams = this.getNewCompanyParams;
//     const commission: IObjectKeys = copyObj(companyParams.commission);

//     if (companyParams.model.business_turn === '') {
//       delete companyParams.model.business_turn;
//     }

//     const dataForReference = {
//       ...companyParams.model,
//       contacts: companyParams.contacts,
//       address: { ...companyParams.address, },
//       commission,
//     };

//     this.model = dataForReference;
//     this.tabIndex = 1;
//     window.scrollTo(0, 0);
//   }

//   saveNewCompany(images: { image: string }[]): void {
//     const teipNotification = new TeipNotifications();
//     if (Object.keys(this.model).length !== 0) {
//       this.saveCompany({
//         model: this.model,
//         images,
//       })
//         .then(() => {
//           this.isSaveSuccess = true;
//           this.newCompanyKey++;
//           this.tabIndex = 0;
//           teipNotification.success(
//             `${this.$t('menu.company.singular.formal')} guardada exitosamente.`
//           );
//         })
//         .catch((error: AxiosError) => {
//           if (error.response && error.response?.status === 422) {
//             // eslint-disable-next-line @typescript-eslint/no-explicit-any
//             const errors: Array<any> = Object.entries(
//               error.response?.data.error
//             );
//             const errorsShow: string[] = [];
//             errors.map(([key, value]) => {
//               if (key.includes('contacts')) {
//                 const keys = key.split('.')[1];
//                 errorsShow[keys] = value;
//               } else {
//                 errorsShow[key] = value;
//               }
//             });
//             this.formValidatorNewCompany.setErrors(errorsShow);
//           } else {
//             teipNotification.warning('Algo salió mal :(');
//           }
//         })
//         .finally(() => {
//           this.isSaveSuccess = false;
//         });
//     } else {
//       this.tabIndex = 0;
//       teipNotification.warning(
//         `¡Información de ${this.$t(
//           'menu.company.singular.informal'
//         )} requerida!`,
//         `Debes completas la información de ${this.$t(
//           'menu.company.singular.informal'
//         )} para poder guardar contactos`
//       );
//     }
//   }

//   @Action(`contactModule/${contactTypes.actions.LIST_CONTACT_KIND}`)
//   listContactKind!: VuexFunction;

//   @Action(`companyModule/${companyTypes.actions.SAVE_COMPANY}`)
//   saveCompany!: VuexFunction;

//   @Action(`documentModule/${document.actions.LIST_DOCUMENT_KIND}`)
//   listDocumentKind!: VuexFunction;

//   @Action(`liquidationModule/${liquidations.actions.LIQUIDATION_KIND_LIST}`)
//   liquidationKindList!: VuexFunction;

//   @Getter(`contactModule/${contactTypes.getters.GET_CONTACT_KIND}`)
//   getContactKind!: responseDataPagination<ContactParams>;

//   @Getter(`companyModule/${companyTypes.getters.GET_NEW_COMPANY_PARAMS}`)
//   getNewCompanyParams!: NewCompanyParams;
// }
